const parsePrice = (
    number,
    decimals,
    decimalChar = ',',
    thousandChar = '.'
  ) => {
    let res = number;
    res = res.toString().replace(',', thousandChar);
    res = parseFloat(res).toFixed(decimals);
    res = res.replace('.', decimalChar);
    const splitNum = res.split(decimalChar);
    splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);
    if (splitNum[1] !== '00') {
      res = splitNum.join(decimalChar);
    } else {
      [res] = splitNum;
    }
    return res;
  };
  
  export const normalizePrice = (amount, decimals) => {
    const priceToShow = amount;
    if (!priceToShow && priceToShow !== 0) {
      return null;
    }
    if (!(typeof priceToShow === 'number' || typeof priceToShow === 'string')) {
      return null;
    }
    return parsePrice(priceToShow, decimals);
  };
  